import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Form } from '@/components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledForm = styled(Form)`
  justify-content: space-between;
  height: 100%;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  color: ${COLORS.DARK_ONYX} !important;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;

export const StyledInstructionBlock = styled.div`
  display: flex;
  width: 100%;
  border-radius: 0.6rem;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: ${COLORS.BLACK_PRIMARY};
  color: ${COLORS.WHITE};
  align-items: flex-start;

  svg {
    margin-right: 0.5rem;
    width: 2.1rem;

    @media screen and ${DEVICES.TABLET_S} {
      width: initial;
    }
  }
`;

export const StyledLink = styled.a`
  &&&& {
    cursor: pointer;
    text-decoration: underline;
    color: ${COLORS.YELLOW_PRIMARY};
  }
`;
